"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditContacts = void 0;
const filter_header_1 = require("client/components/filter-header");
const icons_1 = require("client/components/icons");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const table_row_1 = require("client/components/material/table/table-row");
const text_area_1 = require("client/components/material/text-area/text-area");
const text_field_1 = require("client/components/material/text-field");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/sites/modules/sites-detail/store");
const Table_1 = require("material-ui/Table");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const capitalize_string_1 = require("shared/util/capitalize-string");
const throttle_debounce_1 = require("throttle-debounce");
require("./edit-contacts.less");
// const columns = [
//   {
//     center: false,
//     label: "Type",
//     sortable: false
//   },
//   {
//     center: false,
//     id: "lastName",
//     numeric: false,
//     label: "Name"
//   },
//   {
//     center: false,
//     id: "email",
//     numeric: false,
//     label: "Email"
//   },
//   {
//     center: false,
//     id: "phone",
//     numeric: false,
//     label: "Phone Number"
//   },
//   {
//     center: false,
//     sortable: false,
//     numeric: false,
//     label: "Role"
//   },
//   {
//     center: false,
//     label: "",
//     sortable: false
//   }
// ];
const columns = [
    {
        label: "Type",
        id: ""
    },
    {
        id: "lastName",
        label: "Name"
    },
    {
        id: "email",
        label: "Email"
    },
    {
        id: "phone",
        label: "Phone Number"
    },
    {
        id: "",
        label: "Role"
    },
    {
        id: "",
        label: ""
    }
];
let EditContacts = class EditContacts extends react_1.Component {
    constructor() {
        super(...arguments);
        this.order = "ASC";
        this.orderBy = "lastName";
        this.isCollapse = true;
        this.filterText = "";
        this.autoFocusForm = true;
        this.status = ui_1.FormStatus.Clean;
        this.newData = {
            firstName: "",
            lastName: "",
            email: "",
            group: "",
            phone: "",
            notes: ""
        };
        this.dummyData = {
            id: null,
            firstName: "",
            lastName: "",
            email: "",
            group: "",
            phone: "",
            notes: ""
        };
        this.loadContacts = throttle_debounce_1.debounce(200, async () => {
            console.log(this.order);
            await store_1.sitesDetailStore.loadContacts({
                id: this.siteId,
                order: this.order,
                search: this.filterText,
                sort: this.orderBy
            });
        });
        this.onCallback = (value) => {
            this.autoFocusForm = false;
            this.filterText = value;
            this.loadContacts();
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadContacts();
            router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}/contacts`);
        };
        this.onHandleClickDeleteContact = async (id) => {
            await store_1.sitesDetailStore.deleteContact(id);
            this.loadContacts();
            router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}/contacts`);
        };
        this.renderTable = () => {
            const loadedAndPopulated = !!store_1.sitesDetailStore.users.value && !!store_1.sitesDetailStore.users.value.length;
            console.log(loadedAndPopulated);
            return (React.createElement("div", { className: "site-edit-users__table" },
                React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: loadedAndPopulated ? store_1.sitesDetailStore.users.value : [{ kill: true }], renderRow: this.renderTableRow, wideHeader: false, resizableheader: true, customClass: "custom-material-list__site-contacts-list" })));
        };
        this.renderTableRow = (row, index) => {
            const editingRow = this.props.rowId === index + 1;
            const newContact = this.props.rowId === 0 && index === 0;
            // if (newContact && row.kill) {
            //   return this.renderListRowEditMode(row, index);
            // } else if (row.kill) return;
            // if (newContact) {
            //   return [
            //     this.renderListRowEditMode(row, index),
            //     this.renderTableRowPlain(row, index)
            //   ];
            // }
            // if (editingRow) {
            //   return [
            //     this.renderTableRowPlain(row, index),
            //     this.renderListRowEditMode(row, index)
            //   ];
            // }
            // return this.renderTableRowPlain(row, index);
            if (!(newContact && row.kill) && row.kill) {
                return null;
            }
            return (React.createElement(React.Fragment, null,
                newContact && row.kill ? this.renderListRowEditMode(row, index) : null,
                newContact && !row.kill
                    ? this.renderListRowEditMode(row, index)
                    : null,
                this.renderTableRowPlain(row, index),
                editingRow ? this.renderListRowEditMode(row, index) : null));
        };
        this.renderTableRowPlain = (row, index) => {
            const displayName = row.firstName || row.lastName ? `${row.lastName}, ${row.firstName}` : "";
            const isProv = !!row.title;
            const isUser = !!row.group && row.group.name;
            return (
            // <MaterialTableRow
            //   key={index}
            //   onClick={() => {
            //     if (this.status === FormStatus.Dirty) {
            //       this.status = FormStatus.Clean;
            //     }
            //     RouteManager.transitionTo(
            //       `/pharmacies/${this.siteId}/contacts/${index + 1}`
            //     );
            //   }}
            // >
            //   <TableCell className="users__avatar">
            //     {isProv ? <ProvidersIcon /> : isUser ? <PersonIcon /> : <PenIcon />}
            //     {isProv ? "Provider" : isUser ? "User" : "Write-In"}
            //   </TableCell>
            //   <TableCell className="users__name">{displayName}</TableCell>
            //   <TableCell>{row.email}</TableCell>
            //   <TableCell>{row.phone}</TableCell>
            //   <TableCell>
            //     {isUser ? row.group.name : isProv ? row.title : row.group}
            //   </TableCell>
            //   <TableCell onClick={() => this.onHandleClickDeleteContact(row.id)}>
            //     {!isUser && !isProv ? <DeleteIcon /> : ""}
            //   </TableCell>
            // </MaterialTableRow>
            React.createElement(list_item_1.MaterialListItem, { key: index, onClick: () => {
                    if (this.status === ui_1.FormStatus.Dirty) {
                        this.status = ui_1.FormStatus.Clean;
                    }
                    router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}/contacts/${index + 1}`);
                } },
                React.createElement(list_item_text_1.MaterialListItemText, { className: "users__avatar", 
                    // primary={`${
                    //   isProv ? <ProvidersIcon /> : isUser ? <PersonIcon /> : <PenIcon />
                    // }
                    // ${isProv ? "Provider" : isUser ? "User" : "Write-In"}`}
                    primary: isProv ? (React.createElement(React.Fragment, null,
                        React.createElement(icons_1.ProvidersIcon, null),
                        "Provider")) : isUser ? (React.createElement(React.Fragment, null,
                        React.createElement(icons_1.PersonIcon, null),
                        "User")) : (React.createElement(React.Fragment, null,
                        React.createElement(icons_1.PenIcon, null),
                        "Write-In")) }),
                React.createElement(list_item_text_1.MaterialListItemText, { className: "users__name", primary: capitalize_string_1.capitalizeString(displayName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: row.email }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: row.phone }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: isUser
                        ? capitalize_string_1.capitalizeString(row.group.name)
                        : isProv
                            ? row.title
                            : typeof row.group === "string"
                                ? capitalize_string_1.capitalizeString(row.group)
                                : row.group }),
                React.createElement(list_item_text_1.MaterialListItemText, { onClick: () => this.onHandleClickDeleteContact(row.id), primary: !isUser && !isProv ? React.createElement(icons_1.DeleteIcon, null) : "" })));
        };
        this.handleSubmit = async (rowType) => {
            /** Cut modifications. */
            switch (rowType) {
                case "user":
                    delete this.newData.email;
                case "prov":
                    delete this.newData.group;
                    break;
            }
            this.newData.rowType = rowType;
            await store_1.sitesDetailStore.saveContact(this.newData, this.siteId);
            this.loadContacts();
            router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}/contacts`);
        };
        this.isChanged = () => this.status === ui_1.FormStatus.Dirty;
        this.handleChange = (field) => (event, value) => {
            this.newData[field] = value;
            if (this.status === ui_1.FormStatus.Clean) {
                this.status = ui_1.FormStatus.Dirty;
            }
        };
        this.renderListRowEditMode = (row, index) => {
            const newContact = !this.newData.id;
            const isCustom = newContact || (!!row.group && !row.group.name);
            const isProv = !!row.title;
            const isUser = !isCustom && !isProv;
            const rowType = isCustom ? "custom" : isProv ? "prov" : "user";
            console.log(rowType);
            return (React.createElement(table_row_1.MaterialTableRow, { key: -1 },
                React.createElement(Table_1.TableCell, { colSpan: 6, className: "site-edit-contact" },
                    React.createElement(ui_1.UiForm, { className: "contacts-ui-form", buttons: [
                            "Submit",
                            React.createElement(ui_1.UiButton, { onClick: () => router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}/contacts`) }, "Cancel")
                        ], onSubmit: () => this.handleSubmit(rowType), loading: this.props.loading, 
                        // isChanged={() => false}
                        isChanged: this.isChanged, 
                        // status={() => false}
                        status: this.status, saved: "Saved", error: "" },
                        React.createElement("div", { className: "contacts-row" },
                            React.createElement(text_field_1.MaterialTextField, { className: "contacts-field", label: "First Name", missing: false, 
                                // onChange={(e, v) => (this.newData.firstName = v)}
                                onChange: this.handleChange("firstName"), value: this.newData.firstName || "" }),
                            React.createElement(text_field_1.MaterialTextField, { className: "contacts-field", label: "Last Name", missing: false, 
                                // onChange={(e, v) => (this.newData.lastName = v)}
                                onChange: this.handleChange("lastName"), value: this.newData.lastName || "" }),
                            React.createElement(text_field_1.MaterialTextField, { className: "contacts-field", label: "Role", disabled: !isCustom, 
                                // onChange={(e, v) => (this.newData.group = v)}
                                onChange: this.handleChange("group"), value: this.newData.group || "" })),
                        React.createElement("div", { className: "contacts-row" },
                            React.createElement(text_field_1.MaterialTextField, { className: "contacts-field-long", label: "Email", missing: false, disabled: isUser, 
                                // onChange={(e, v) => (this.newData.email = v)}
                                onChange: this.handleChange("email"), value: this.newData.email || "" }),
                            React.createElement(text_field_1.MaterialTextField, { className: "contacts-field-long", leftItem: React.createElement(icons_1.PhoneIcon, null), label: "Phone", 
                                // onChange={(e, v) => (this.newData.phone = v)}
                                onChange: this.handleChange("phone"), value: this.newData.phone || "" })),
                        React.createElement("div", { className: "contacts-row" },
                            React.createElement(text_area_1.MaterialTextArea, { className: "contacts-notes", 
                                // onChange={(e, v) => (this.newData.notes = v)}
                                onChange: this.handleChange("notes"), placeholder: "Notes", value: this.newData.notes || "" }))))));
        };
    }
    componentWillMount() {
        this.siteId = this.props.site ? this.props.site : 0;
        this.rowId = !isNaN(this.props.rowId) ? this.props.rowId : null;
    }
    async componentDidMount() {
        await this.loadContacts();
    }
    componentWillReceiveProps(props) {
        this.siteId = props.site ? props.site : 0;
        this.rowId = !isNaN(props.rowId) ? props.rowId : null;
        if (!!this.rowId && store_1.sitesDetailStore.users.value) {
            const row = store_1.sitesDetailStore.users.value[this.rowId - 1] || [];
            const gDisplay = row.group && row.group.name
                ? row.group.name
                : row.group
                    ? row.group
                    : row.title;
            console.log(row.group);
            this.oldData = {
                id: row.id || null,
                firstName: row.firstName || "",
                lastName: row.lastName || "",
                email: row.email || "",
                group: gDisplay || "",
                phone: row.phone || "",
                notes: row.notes || ""
            };
            this.newData = this.oldData;
        }
        else {
            this.newData = this.dummyData;
        }
    }
    componentDidUpdate() {
        this.isCollapse = true;
        this.rowId = null;
        this.oldData = null;
    }
    render() {
        return (React.createElement("div", { className: "site-edit-users" },
            this.renderFilter(),
            this.renderTable()));
    }
    renderFilter() {
        return (React.createElement("div", { className: "users__filter" },
            React.createElement(filter_header_1.FilterHeader, { callBack: this.onCallback, filterText: this.filterText })));
    }
};
__decorate([
    mobx_1.observable
], EditContacts.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EditContacts.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EditContacts.prototype, "isCollapse", void 0);
__decorate([
    mobx_1.observable
], EditContacts.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EditContacts.prototype, "autoFocusForm", void 0);
__decorate([
    mobx_1.observable
], EditContacts.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], EditContacts.prototype, "newData", void 0);
EditContacts = __decorate([
    mobx_react_1.observer
], EditContacts);
exports.EditContacts = EditContacts;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/components/edit-contacts/edit-contacts.tsx
// module id = 4012
// module chunks = 0